import type { NotificationCategory } from '@/services/notificationService';

const FILTERS: { id: NotificationCategory; label: string }[] = [
  { id: 'all', label: 'Semua' },
  { id: 'event', label: 'Event' },
  { id: 'booking', label: 'Booking' },
  { id: 'community', label: 'Komunitas' },
];

interface NotificationFiltersProps {
  value: NotificationCategory;
  onChange: (value: NotificationCategory) => void;
}

export function NotificationFilters({ value, onChange }: NotificationFiltersProps) {
  return (
    <div className="flex items-center gap-2 overflow-x-auto no-scrollbar pb-1">
      {FILTERS.map((filter) => {
        const active = value === filter.id;
        return (
          <button
            key={filter.id}
            type="button"
            onClick={() => onChange(filter.id)}
            className={`px-4 py-2 rounded-full text-sm font-semibold whitespace-nowrap cursor-pointer transition-colors ${
              active ? 'bg-[#FC480D] text-white' : 'bg-white text-[#0E1726] border border-[#E0E6ED]'
            }`}
          >
            {filter.label}
          </button>
        );
      })}
    </div>
  );
}
